module.exports = __webpack_public_path__ + "static/img/logo.7744ea87.png";